/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */
import {Component} from '@angular/core';

import {takeUntil, tap} from 'rxjs/operators';

import {ESSService} from '../../../+ess/employee-self.service';
import {environment} from '../../../../environments/environment';
import {Destroyable} from '../../../destroyable.component';
import {CommunicationsService} from '../../../inbox/shared/communications.service';
import {ApiService} from '../../../shared/api';
import {ModalService} from '../../../shared/modal';
import {CliCorePropertiesService} from '../../cli-core-properties.service';

/**
 * Menu component : left or right aside menu with the main user navigation in direct links or drop-down items.
 */
@Component({
  selector: 'gp-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})

export class MenuComponent extends Destroyable {

  public configToolUrl: string = environment.CONFIG_TOOL_URL;
  public displayTemplateManagement = false;
  public displayAccountingManagement: boolean;
  public displayPaymentV2: boolean;
  public displayOnboardingAdmin: boolean;
  public tasksUnreadCount: string;
  public enableFctu = false;

  constructor(public essService: ESSService,
              private api: ApiService,
              private cliCorePropertiesService: CliCorePropertiesService,
              public communicationsService: CommunicationsService,
              private modalService: ModalService
  ) {
    super();
    this.cliCorePropertiesService.get().subscribe(() => {
      this.displayAccountingManagement = localStorage.getItem('gp_accounting_management_enabled') === 'true';
      this.displayTemplateManagement = localStorage.getItem('gp_template_management_enabled') === 'true';
      this.displayPaymentV2 = localStorage.getItem('gp_payment_v2_enabled') === 'true';
      this.displayOnboardingAdmin = localStorage.getItem('gp_onboarding_admin_enabled') === 'true';
    });

    this.api.silent.get('/net-entreprise/config').pipe(
      tap(response =>
        this.enableFctu = response['gp.misc.display.fctu']
      )
    ).subscribe();
  }

  public closeSideModal(): void {
    this.modalService.modalClosed.emit('aside');
  }
}
